module.exports = __webpack_public_path__ + "img/header-logo.4cae795e.svg";